import { USER_LOGOUT } from "../constants/userConstants";
import {
    GROCERY_V2_ITEM_GET_REQUEST,
    GROCERY_V2_ITEM_GET_SUCCESS,
    GROCERY_V2_ITEM_GET_FAIL,
    GROCERY_V2_ITEM_CREATE_REQUEST,
    GROCERY_V2_ITEM_CREATE_SUCCESS,
    GROCERY_V2_ITEM_CREATE_FAIL,
    GROCERY_V2_ITEM_UPDATE_REQUEST,
    GROCERY_V2_ITEM_UPDATE_SUCCESS,
    GROCERY_V2_ITEM_UPDATE_FAIL,
    GROCERY_V2_ITEM_DELETE_REQUEST,
    GROCERY_V2_ITEM_DELETE_SUCCESS,
    GROCERY_V2_ITEM_DELETE_FAIL,
    GROCERY_V2_ITEM_UPDATE_MULTIPLE_REQUEST,
    GROCERY_V2_ITEM_UPDATE_MULTIPLE_SUCCESS,
    GROCERY_V2_ITEM_UPDATE_MULTIPLE_FAIL,
    GROCERY_V2_CATEGORY_GET_REQUEST,
    GROCERY_V2_CATEGORY_GET_SUCCESS,
    GROCERY_V2_CATEGORY_GET_FAIL,
    GROCERY_V2_CATEGORY_CREATE_REQUEST,
    GROCERY_V2_CATEGORY_CREATE_SUCCESS,
    GROCERY_V2_CATEGORY_CREATE_FAIL,
    GROCERY_V2_CATEGORY_UPDATE_REQUEST,
    GROCERY_V2_CATEGORY_UPDATE_SUCCESS,
    GROCERY_V2_CATEGORY_UPDATE_FAIL,
    GROCERY_V2_CATEGORY_DELETE_REQUEST,
    GROCERY_V2_CATEGORY_DELETE_SUCCESS,
    GROCERY_V2_CATEGORY_DELETE_FAIL,
    GROCERY_V2_CATEGORY_UPDATE_MULTIPLE_REQUEST,
    GROCERY_V2_CATEGORY_UPDATE_MULTIPLE_SUCCESS,
    GROCERY_V2_CATEGORY_UPDATE_MULTIPLE_FAIL,
    GROCERY_V2_ITEM_DELETE_CHECKED_REQUEST,
    GROCERY_V2_ITEM_DELETE_CHECKED_SUCCESS,
    GROCERY_V2_ITEM_DELETE_CHECKED_FAIL,
    GROCERY_V2_ITEM_CHECK_REQUEST,
    GROCERY_V2_ITEM_CHECK_SUCCESS,
    GROCERY_V2_ITEM_CHECK_FAIL,
    GROCERY_V2_FAVORITES_GET_REQUEST,
    GROCERY_V2_FAVORITES_GET_SUCCESS,
    GROCERY_V2_FAVORITES_GET_FAIL,
    GROCERY_V2_FAVORITES_CREATE_REQUEST,
    GROCERY_V2_FAVORITES_CREATE_SUCCESS,
    GROCERY_V2_FAVORITES_CREATE_FAIL,
    GROCERY_V2_FAVORITES_DELETE_REQUEST,
    GROCERY_V2_FAVORITES_DELETE_SUCCESS,
    GROCERY_V2_FAVORITES_DELETE_FAIL,
    GROCERY_V2_UNDO_LIST_SUCCESS,
    GROCERY_V2_UNDO_LIST_FAIL
} from "../constants/groceryV2Constants";

// Item Reducers
export const groceryV2ItemGetReducer = (state={}, action) => {
    switch(action.type) {
        case GROCERY_V2_ITEM_GET_REQUEST:
            return { loading: true };
        case GROCERY_V2_ITEM_GET_SUCCESS:
            return { loading: false, groceryV2Items: action.payload };
        case GROCERY_V2_ITEM_GET_FAIL:
            return { loading: false, error: action.payload };
        case USER_LOGOUT:
            return {};
        default:
            return state;
    }
}

export const groceryV2ItemCreateReducer = (state={}, action) => {
    switch(action.type) {
        case GROCERY_V2_ITEM_CREATE_REQUEST:
            return { loading: true };
        case GROCERY_V2_ITEM_CREATE_SUCCESS:
            return { loading: false, success: true, groceryV2Item: action.payload };
        case GROCERY_V2_ITEM_CREATE_FAIL:
            return { loading: false, error: action.payload, success: false };
        default:
            return state;
    }
}

export const groceryV2ItemUpdateReducer = (state={}, action) => {
    switch(action.type) {
        case GROCERY_V2_ITEM_UPDATE_REQUEST:
            return { loading: true };
        case GROCERY_V2_ITEM_UPDATE_SUCCESS:
            return { loading: false, success: true, groceryV2Item: action.payload };
        case GROCERY_V2_ITEM_UPDATE_FAIL:
            return { loading: false, error: action.payload, success: false };
        default:
            return state;
    }
}

export const groceryV2ItemDeleteReducer = (state={}, action) => {
    switch(action.type) {
        case GROCERY_V2_ITEM_DELETE_REQUEST:
            return { loading: true };
        case GROCERY_V2_ITEM_DELETE_SUCCESS:
            return { loading: false, success: true };
        case GROCERY_V2_ITEM_DELETE_FAIL:
            return { loading: false, error: action.payload, success: false };
        default:
            return state;
    }
}

export const groceryV2ItemUpdateMultipleReducer = (state={}, action) => {
    switch(action.type) {
        case GROCERY_V2_ITEM_UPDATE_MULTIPLE_REQUEST:
            return { loading: true };
        case GROCERY_V2_ITEM_UPDATE_MULTIPLE_SUCCESS:
            return { loading: false, success: true, groceryV2Items: action.payload };
        case GROCERY_V2_ITEM_UPDATE_MULTIPLE_FAIL:
            return { loading: false, error: action.payload, success: false };
        default:
            return state;
    }
}

// Category Reducers
export const groceryV2CategoryGetReducer = (state={}, action) => {
    switch(action.type) {
        case GROCERY_V2_CATEGORY_GET_REQUEST:
            return { loading: true };
        case GROCERY_V2_CATEGORY_GET_SUCCESS:
            return { loading: false, groceryV2Categories: action.payload };
        case GROCERY_V2_CATEGORY_GET_FAIL:
            return { loading: false, error: action.payload };
        case USER_LOGOUT:
            return {};
        default:
            return state;
    }
}

export const groceryV2CategoryCreateReducer = (state={}, action) => {
    switch(action.type) {
        case GROCERY_V2_CATEGORY_CREATE_REQUEST:
            return { loading: true };
        case GROCERY_V2_CATEGORY_CREATE_SUCCESS:
            return { loading: false, success: true, groceryV2Category: action.payload };
        case GROCERY_V2_CATEGORY_CREATE_FAIL:
            return { loading: false, error: action.payload, success: false };
        default:
            return state;
    }
}

export const groceryV2CategoryUpdateReducer = (state={}, action) => {
    switch(action.type) {
        case GROCERY_V2_CATEGORY_UPDATE_REQUEST:
            return { loading: true };
        case GROCERY_V2_CATEGORY_UPDATE_SUCCESS:
            return { loading: false, success: true, groceryV2Category: action.payload };
        case GROCERY_V2_CATEGORY_UPDATE_FAIL:
            return { loading: false, error: action.payload, success: false };
        default:
            return state;
    }
}

export const groceryV2CategoryDeleteReducer = (state={}, action) => {
    switch(action.type) {
        case GROCERY_V2_CATEGORY_DELETE_REQUEST:
            return { loading: true };
        case GROCERY_V2_CATEGORY_DELETE_SUCCESS:
            return { loading: false, success: true };
        case GROCERY_V2_CATEGORY_DELETE_FAIL:
            return { loading: false, error: action.payload, success: false };
        default:
            return state;
    }
}

export const groceryV2CategoryUpdateMultipleReducer = (state={}, action) => {
    switch(action.type) {
        case GROCERY_V2_CATEGORY_UPDATE_MULTIPLE_REQUEST:
            return { loading: true };
        case GROCERY_V2_CATEGORY_UPDATE_MULTIPLE_SUCCESS:
            return { loading: false, success: true, groceryV2Categories: action.payload };
        case GROCERY_V2_CATEGORY_UPDATE_MULTIPLE_FAIL:
            return { loading: false, error: action.payload, success: false };
        default:
            return state;
    }
}

export const groceryV2ItemDeleteCheckedReducer = (state={}, action) => {
    switch(action.type) {
        case GROCERY_V2_ITEM_DELETE_CHECKED_REQUEST:
            return { loading: true };
        case GROCERY_V2_ITEM_DELETE_CHECKED_SUCCESS:
            return { loading: false, success: true, message: action.payload.message };
        case GROCERY_V2_ITEM_DELETE_CHECKED_FAIL:
            return { loading: false, error: action.payload, success: false };
        default:
            return state;
    }
}

export const groceryV2ItemCheckReducer = (state={}, action) => {
    switch(action.type) {
        case GROCERY_V2_ITEM_CHECK_REQUEST:
            return { loading: true };
        case GROCERY_V2_ITEM_CHECK_SUCCESS:
            return { loading: false, success: true, groceryV2Item: action.payload };
        case GROCERY_V2_ITEM_CHECK_FAIL:
            return { loading: false, error: action.payload, success: false };
        default:
            return state;
    }
}

// Favorites Reducers
export const groceryV2FavoritesGetReducer = (state={}, action) => {
    switch(action.type) {
        case GROCERY_V2_FAVORITES_GET_REQUEST:
            return { loading: true };
        case GROCERY_V2_FAVORITES_GET_SUCCESS:
            return { loading: false, groceryV2Favorites: action.payload };
        case GROCERY_V2_FAVORITES_GET_FAIL:
            return { loading: false, error: action.payload };
        case USER_LOGOUT:
            return {};
        default:
            return state;
    }
}

export const groceryV2FavoritesCreateReducer = (state={}, action) => {
    switch(action.type) {
        case GROCERY_V2_FAVORITES_CREATE_REQUEST:
            return { loading: true };
        case GROCERY_V2_FAVORITES_CREATE_SUCCESS:
            return { loading: false, success: true, groceryV2Favorites: action.payload };
        case GROCERY_V2_FAVORITES_CREATE_FAIL:
            return { loading: false, error: action.payload, success: false };
        default:
            return state;
    }
}

export const groceryV2FavoritesDeleteReducer = (state={}, action) => {
    switch(action.type) {
        case GROCERY_V2_FAVORITES_DELETE_REQUEST:
            return { loading: true };
        case GROCERY_V2_FAVORITES_DELETE_SUCCESS:
            return { loading: false, success: true, groceryV2Favorites: action.payload };
        case GROCERY_V2_FAVORITES_DELETE_FAIL:
            return { loading: false, error: action.payload, success: false };
        default:
            return state;
    }
}

// Undo Reducer
export const groceryV2UndoListReducer = (state = { undoList: [] }, action) => {
    switch(action.type) {
        case GROCERY_V2_UNDO_LIST_SUCCESS:
            return { undoList: action.payload };
        case GROCERY_V2_UNDO_LIST_FAIL:
            return { error: action.payload };
        case USER_LOGOUT:
            return { undoList: [] };
        default:
            return state;
    }
}
